import { Link } from 'react-router-dom';

import { Button } from 'components/ui/button';

/**
 * 404.
 *
 * Sin Chakra: `Flex`, `Box` y `Text` eran tres utilidades de Tailwind, así que migrar el botón se
 * llevó el fichero entero. Es uno de los dos únicos sitios vivos donde se veía un
 * `ArcaPrimaryButton` — el resto de sus 44 usos están en ficheros que no importa nadie.
 *
 * El botón va con `asChild` sobre el `Link`: así el enlace ES el botón y sale un `<a>` de verdad,
 * en lugar de un `<button>` metido dentro de un enlace, que es lo que había. Eso último son dos
 * paradas del tabulador para una sola acción, y los lectores de pantalla lo anuncian dos veces.
 */
const NotFoundPage = () => (
	<div className="flex h-screen items-center justify-center">
		<div className="text-center">
			<p className="mb-4 text-3xl font-bold">Página no encontrada</p>
			<p className="mb-6">Lo sentimos, la página que estás buscando no existe.</p>
			<Button asChild>
				<Link to="/">Volver al inicio</Link>
			</Button>
		</div>
	</div>
);

export default NotFoundPage;
